import { Injectable, Optional } from "@angular/core";
import { collectionData, Firestore, limit, orderBy, query, QueryConstraint, where } from "@angular/fire/firestore";
import { ElasticSearchService, ESExtras } from "@common/api-server";
import { EsFirestoreBase } from "@common/helpers/es-firestore-base";
import { ExSrvEcosysAssetModel } from "@shared/models/exSrvEcosysAsset.model";
import { Observable } from "rxjs";

const ES_EXTRA: ESExtras = {
}

const ES_SOURCE = null; 
const DATE_PROPERTIES = ['createdAt', 'updatedAt']

export type Model = ExSrvEcosysAssetModel;
const collectionName = 'exSrvEcosysAssets'
@Injectable({
  providedIn: 'root'
})
export class ExSrvEcosysAssetDbService extends EsFirestoreBase<Model>{
  override collectionName = collectionName;
  constructor(
    @Optional() protected override firestore: Firestore,
    protected override es: ElasticSearchService,

  ) {
    super(firestore, es, collectionName, ES_EXTRA, ES_SOURCE, DATE_PROPERTIES);
  }

  queryBy$(options):Observable<Array<Model>> {
    let _where: QueryConstraint[] = [];
    for (const key in options) {
      _where.push(where(key, '==', options[key]));
    }
    _where.push(limit(100));
    const _query = query(this.collection, ..._where);
    return collectionData(_query, { idField: 'id' })
  }

}